import { ICellRendererParams } from 'ag-grid-community';
import CellCard from '../cellCard';

export default function Manufacturer(params: ICellRendererParams) {
    const { manufacturers } = params.data;
    return <CellCard dataArray={manufacturers || []} limit={3} />;
}
